import { motion } from "framer-motion";
import EnquiryContactForm from "../contact/EnquiryContactForm";
import Lottie from "react-lottie";
import Enquirylottie from "../lottie/enquiry.json";

const Enquiry = () => {
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: Enquirylottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        ease: "easeInOut",
        duration: 0.5,
        delay: 0.1,
      }}
      className="container mx-auto flex flex-col-reverse lg:flex-row py-5 lg:py-10 lg:mt-5"
    >
      <EnquiryContactForm />
      <Lottie options={lottieOptions} height={"100%"} width={"40%"} style={{ marginTop: "40px" }}  />
    </motion.div>
  );
};

export default Enquiry;
